import { ERubric } from '../../types/rubricsLinks';

export const RENT = 'Аренда';
export const SALE = 'Продажа';
export const RESIDENTIAL_COMPLEXES = 'Новостройки';
export const COMMERCIAL = 'Коммерческая';
export const MORTGAGE = 'Ипотека';
export const VALUATION = 'Оценка';
export const EXTRA = 'Ещё';
export const SERVICES = 'Сервисы';

type TypedObject = {
  [key in `${ERubric}`]: string;
};

export const RUBRIC_NAMES: TypedObject = {
  [ERubric.Rent]: RENT,
  [ERubric.Sale]: SALE,
  [ERubric.ResidentialComplexes]: RESIDENTIAL_COMPLEXES,
  [ERubric.Commercial]: COMMERCIAL,
  [ERubric.Evaluation]: VALUATION,
  [ERubric.Mortgage]: MORTGAGE,
  [ERubric.Services]: SERVICES,
  [ERubric.Extra1024]: EXTRA,
  [ERubric.Extra1093]: EXTRA,
  [ERubric.OldExtra1024]: EXTRA,
  [ERubric.OldExtra1093]: EXTRA,
};

export const OLD_NAVBAR_RUBRICS: ERubric[] = [
  ERubric.Rent,
  ERubric.Sale,
  ERubric.ResidentialComplexes,
  ERubric.Commercial,
  ERubric.Evaluation,
  ERubric.Mortgage,
  ERubric.OldExtra1093,
  ERubric.OldExtra1024,
];

export const NAVBAR_RUBRICS: ERubric[] = [
  ERubric.Rent,
  ERubric.Sale,
  ERubric.ResidentialComplexes,
  ERubric.Commercial,
  ERubric.Mortgage,
  ERubric.Services,
  ERubric.Extra1093,
  ERubric.Extra1024,
];
